import type {ReactElement} from 'react';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {useAiChatLayout} from '@AiChat/hooks/useAiChatLayout';
import {useAiChatSeason} from '@AiChat/hooks/useAiChatSeason';
import {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';
import {AiChatHalloweenPumpkins} from '@AiChat/components/ai-chat-halloween-pumpkins/ai-chat-halloween-pumpkins';
import {assertNever} from '@Utils/assert-never.util';
import styles from './ai-chat-seasonal-returning-user-decorations.module.scss';

export function AiChatSeasonalReturningUserDecorations(): ReactElement | null {
  const {isSmall} = useAiChatSize();
  const {showsSidebarRail} = useAiChatLayout();
  const season = useAiChatSeason();

  if (!season || isSmall) {
    return null;
  }

  switch (season) {
    case AiChatSeason.HALLOWEEN:
      return <AiChatHalloweenPumpkins pumpkinSetClasses={`${styles.pumpkins} ${showsSidebarRail ? styles.pumpkinsBesideRail : ''}`} />;
    default:
      return assertNever(season);
  }
}
